<template>
  <div>
    <v-list-item to="/">
        <v-list-item-content>
          <v-list-item-title >الرئيسية</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    <div v-for="category in categories" :key="category.id">
      
      <v-list-item
        :to="`/category/${category.outlineId}`"
        v-if="category.subCategories.length === 0"
        link
      >
        <v-list-item-content>
          <v-list-item-title>{{ category.name | localized }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group v-else no-action value="true">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{
              category.name | localized
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          :to="`/category/${subCategory.outlineId}`"
          v-for="(subCategory, i) in category.subCategories"
          :key="i"
          link
        >
          <v-list-item-title>{{
            subCategory.name | localized
          }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

          
    </div>
  <!--   <v-list-item to="/HelpRequest">
        <v-list-item-content>
          <v-list-item-title >نظام المساعدات المركزي</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CategoriesListMenu",

  //********************** */
  data: () => ({
    //
  }),

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      categories: "categories",
    }),
    ...mapGetters("Account", {
      language: "language",
    }),
  },
  methods: {
    isLeft: function () {
      return this.language === "ar";
    },
  },
};
</script>

<style>
</style>